var checkboxSvg = {
    base: {
        opacity: 1,
        color: "white",
        overflow: "visible",
        ".cb-bordered": { color: "black.100", fill: "white", stroke: "black.20" },
        ".cb-solid": { display: "none", fill: "primary.100" },
        ".check, .minus": { stroke: "white", fill: "white" },
        ".check": { display: "none" },
        ".focus": {
            display: "none",
            fill: "focus.shadow",
            transformOrigin: "center",
        },
    },
    variants: {
        isIndeterminate: {
            true: {
                ".cb-solid": { display: "block" },
            },
        },
        isFocused: {
            true: {
                ".focus": { display: "block" },
                ".cb-bordered": { stroke: "primary.100" },
            },
        },
        isDisabled: {
            true: {
                ".cb-solid": { opacity: 0.5 },
                ".cb-bordered": { fill: "black.5" },
            },
        },
        isChecked: {
            true: {
                ".check": { display: "block" },
                ".cb-solid": { display: "block" },
                ".cb-bordered": { display: "none" },
                ".minus": { display: "none" },
            },
        },
        size: {
            // sizes include focus ring
            sm: {
                // 16 + 16 / 4
                width: "20px",
                height: "20px",
                ".focus": {
                    transform: "scale(1.1)",
                },
                ".check, .minus": { strokeWidth: 4 },
                ".cb-bordered": { strokeWidth: 7 },
            },
            md: {
                // 20 + 20 / 4
                width: "25px",
                height: "25px",
                ".focus": {
                    transform: "scale(1.06)",
                },
                ".check, .minus": { strokeWidth: 3 },
                ".cb-bordered": { strokeWidth: 5 },
            },
            lg: {
                // 24 + 24 / 4
                width: "30px",
                height: "30px",
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

export { checkboxSvg };
//# sourceMappingURL=checkbox-svg.js.map
